// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bVzP","comment":"styles_comment__3I2hn"};